import { render, staticRenderFns } from "./CtaTitle.vue?vue&type=template&id=126996be&"
import script from "./CtaTitle.vue?vue&type=script&lang=js&"
export * from "./CtaTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports